import { useTwoFactorLogin } from "../../../hooks/useTwoFactorLogin";

export function useVerify() {
  const { verify, isVerifying } = useTwoFactorLogin();

  return {
    isLoading: isVerifying,
    initiate: async (otp, altType) =>
      verify({ code: otp, trustDevice: false }, altType),
  };
}
